<template>
  <div class="is-marginless is-paddingless section section-logo">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('choixSousTypeBailleur.title') }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button btn-modal-annuler" @click="$router.go(-1)">
              {{ $t('general.button.cancel') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="link-box-container">
      <div v-for="bailleur in listeTypeBailleur" :key="bailleur.sousType">
        <router-link :to="{ name: 'm.baux.bailleur-ajout',
        params: { sousType: bailleur.sousType} }"
                     class="link-box"
                     :class="{'text-access-no-permission' : !checkPermissions(permsBailleur.maj)}">
          <div :class="bailleur.classLogo"/>
          <p class="has-text-weight-bold is-size-4 has-text-centered">
            {{ $t(bailleur.title) }}
          </p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import {
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_PRO,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
} from '@/configuration/tiers/tiersConf';
import { BAILLEUR } from '@/configuration/baux/permissionsBauxConf';
import AppBreadcrumb from '@/components/general/breadcrumb';

const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      permsBailleur: BAILLEUR,
    };
  },
  components: {
    AppBreadcrumb,
  },
  mounted() {
    this.setInformationPage(this.$t('pageBaux.bailleur.creation'));
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('choixSousTypeBailleur.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('choixSousTypeBailleur.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    listeTypeBailleur() {
      return [
        { classLogo: 'logo__bailleurPro', sousType: TIERS_SOUS_TYPE_BAILLEUR_PRO, title: 'choixSousTypeBailleur.sousTypes.pro' },
        { classLogo: 'logo__bailleurPrive', sousType: TIERS_SOUS_TYPE_BAILLEUR_PRIVE, title: 'choixSousTypeBailleur.sousTypes.prive' },
        { classLogo: 'logo__bailleurConcession', sousType: TIERS_SOUS_TYPE_BAILLEUR_CONCESSION, title: 'choixSousTypeBailleur.sousTypes.concession' },
        { classLogo: 'logo__bailleurPro', sousType: TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE, title: 'choixSousTypeBailleur.sousTypes.administrationEtAssimilee' },
      ];
    },
  },
};
</script>
